

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectLicenseComponent } from './select-license.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [SelectLicenseComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    
  ],
  exports: [SelectLicenseComponent],
  entryComponents: [SelectLicenseComponent],
})
export class SelectLicenseModule { }
